import React, { useCallback, useEffect, useState } from 'react';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import RichTextContent from '../../RichTextRenderer';
import { FullUserGuideModel, InnerViewProps } from '../types';
import { getUserGuide } from '../utils';

interface HelpAttachmentGuidesViewProps extends InnerViewProps {
  slug: string;
}
const HelpAttachmentGuidesView: React.FC<HelpAttachmentGuidesViewProps> = ({
  goBack,
  slug,
  appData,
}) => {
  const [item, setItem] = useState<FullUserGuideModel | null>(null);

  const getGuide = useCallback(async () => {
    const userGuide = await getUserGuide(appData.appToken, slug);
    if (userGuide) {
      setItem(userGuide);
    }
  }, [slug, appData.appToken]);

  useEffect(() => {
    getGuide();
  }, [getGuide]);

  return (
    <>
      <div className="bg-gradient-to-b from-green-500 to-green-600 p-3 py-5 flex justify-between items-center">
        <div
          onClick={goBack}
          className="cursor-pointer hover:bg-green-700 p-2 rounded"
        >
          <AiOutlineArrowLeft />{' '}
        </div>
        <div className="font-medium text-lg">
          {item?.title ?? 'Guide not found'}
        </div>
        <div className="w-6"></div>
      </div>
      {item && (
        <div className="p-4 text-black">
          <RichTextContent>{item.content}</RichTextContent>
        </div>
      )}
    </>
  );
};

export default HelpAttachmentGuidesView;
